import { decryptToken, encryptToken } from "./criptografiaToken";

const tokenKey = "token";
const itemsMenuKey = "itensMenu";
const nomeCompletoKey = "nomeCompleto";
const tipoCadastroPlanTribKey = "tipoCadastroPlanTribKey";
const emailKey = "email";
const statusKey = "status";
const idUsuarioKey = "idUsuario";
const permissoesChavesKey = "permissoesChaves";

export const Token = {
  setToken: (value) => localStorage.setItem(tokenKey, encryptToken(value)),
  getToken: () => decryptToken(localStorage.getItem(tokenKey)),
  removeToken: () => localStorage.removeItem(tokenKey),
};

export const ItemsMenu = {
  setItemsMenu: (value) => localStorage.setItem(itemsMenuKey, value),
  getItemsMenu: () => localStorage.getItem(itemsMenuKey),
  removeItemsMenu: () => localStorage.removeItem(itemsMenuKey),
};

export const NomeCompleto = {
  setNomeCompleto: (value) => localStorage.setItem(nomeCompletoKey, value),
  getNomeCompleto: () => localStorage.getItem(nomeCompletoKey),
  removeNomeCompleto: () => localStorage.removeItem(nomeCompletoKey),
};

// export const TipoCadastroPlanTrib = {
//   setTipoCadastroPlanTrib: (value) =>
//     localStorage.setItem(tipoCadastroPlanTribKey, value),
//   getTipoCadastroPlanTrib: () => localStorage.getItem(tipoCadastroPlanTribKey),
//   removeTipoCadastroPlanTrib: () =>
//     localStorage.removeItem(tipoCadastroPlanTribKey),
// };

// export const Email = {
  // setEmail: (value) => localStorage.setItem(emailKey, value),
  // getEmail: () => localStorage.getItem(emailKey),
  // removeEmail: () => localStorage.removeItem(emailKey),
// };

export const Status = {
  setStatus: (value) => localStorage.setItem(statusKey, value),
  getStatus: () => localStorage.getItem(statusKey),
  removeStatus: () => localStorage.removeItem(statusKey),
};

export const IdUsuario = {
  setUserId: (value) => localStorage.setItem(idUsuarioKey, String(value ?? "")),
  getUserId: () => {
    const v = localStorage.getItem(idUsuarioKey);
    return v != null && v !== "" ? v : null;
  },
  removeUserId: () => localStorage.removeItem(idUsuarioKey),
};

/** Cache JSON das chaves retornadas por GET /usuarios/minhas-permissoes (TXM-216). */
export const PermissoesChaves = {
  set: (value) => localStorage.setItem(permissoesChavesKey, value),
  get: () => localStorage.getItem(permissoesChavesKey),
  remove: () => localStorage.removeItem(permissoesChavesKey),
};